import type { ThemeTokens } from '../types';

/**
 * Default theme — every value exactly mirrors the :root block in variables.css.
 * This is the canonical reference. If these values diverge from variables.css,
 * teal-light users will see a brief flash on first load.
 */
export const tealLight: ThemeTokens = {
  id: 'teal-light',
  name: 'Teal Light',
  colorMode: 'light',

  // Brand
  primaryColor:    '#3a8d8d',
  primaryLight:    '#5bb0b0',
  primaryDark:     '#2c6e6e',
  primarySubtle:   '#e4efee',
  hoverColor:      '#e4efee',
  activeColor:     '#cce9e9',
  buttonFocusRing: 'rgba(58, 141, 141, 0.35)',
  shadowPrimary:   '0 4px 12px rgba(58, 141, 141, 0.25)',
  shadowPrimarySm: '0 1px 2px rgba(58, 141, 141, 0.20)',
  gradientBrand:   'linear-gradient(135deg, #3a8d8d 0%, #2563eb 100%)',
  gradientBrandR:  'linear-gradient(135deg, #2563eb 0%, #3a8d8d 100%)',
  gradientSubtle:  '#e4efee',
  infoColor:       '#3a8d8d',

  // Brand alpha
  primaryAlpha12: 'rgba(58, 141, 141, 0.12)',
  primaryAlpha15: 'rgba(58, 141, 141, 0.15)',
  primaryAlpha18: 'rgba(58, 141, 141, 0.18)',
  primaryAlpha20: 'rgba(58, 141, 141, 0.20)',
  primaryAlpha25: 'rgba(58, 141, 141, 0.25)',
  primaryAlpha30: 'rgba(58, 141, 141, 0.30)',
  primaryAlpha35: 'rgba(58, 141, 141, 0.35)',
  primaryAlpha40: 'rgba(58, 141, 141, 0.40)',

  // Surface
  bgColor:     '#f8fafc',
  bgSubtle:    '#f1f5f9',
  cardBgColor: '#ffffff',

  // Text
  textDark:    '#0f172a',
  textMedium:  '#475569',
  textLight:   '#94a3b8',
  textInverse: '#ffffff',

  // Border
  borderColor: '#e2e8f0',
  borderLight: '#f1f5f9',

  // Shadows
  shadowXs: '0 1px 2px rgba(15, 23, 42, 0.04)',
  shadowSm: '0 1px 3px rgba(15, 23, 42, 0.08), 0 1px 2px rgba(15, 23, 42, 0.04)',
  shadowMd: '0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04)',
  shadowLg: '0 12px 28px rgba(15, 23, 42, 0.1), 0 4px 8px rgba(15, 23, 42, 0.06)',
  shadowXl: '0 24px 48px rgba(15, 23, 42, 0.12), 0 8px 16px rgba(15, 23, 42, 0.06)',

  // Status
  successBg:     '#f0fdf4',
  successBorder: '#bbf7d0',
  successText:   '#15803d',
  warningBg:     '#fffbeb',
  warningBorder: '#fde68a',
  warningText:   '#92400e',
  dangerBg:      '#fef2f2',
  dangerBorder:  '#fecaca',
  dangerText:    '#dc2626',
  infoBg:        '#e8f1fe',
  infoBorder:    '#bfdbfe',
  infoText:      '#1e40af',

  // Interaction
  dangerHoverBg: '#fef2f2',
  backdropColor: 'rgba(11, 17, 32, 0.55)',

  // Fonts
  fontSans:       "'Inter', system-ui, -apple-system, sans-serif",
  fontMono:       "'DM Mono', ui-monospace, 'Cascadia Code', monospace",
  fontDisplay:    "'Inter', system-ui, -apple-system, sans-serif",
  googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=DM+Mono:wght@400;500&display=swap',
};
